import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { Config } from '@/config';
import {
  errorModalTextRecoil,
  completeModalRecoil,
  modifyModalRecoil,
  noticeModifyModalRecoil,
} from '@/atom/ModalAtom';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import LS from '@/styles/layoutStyled';
import CS from '@/styles/componentStyled';
import BS from '@/styles/btnStyled';
import IS from '@/styles/inputStyled';
import ModalType1 from '@/modal/ModalType1';
import { NotcieApi } from '@/sdk/NotcieApi';
import {
  UpdateNoticeDtoTx,
  SiteControllerCheckSiteParams,
} from '@/sdk/data-contracts';

interface NoticeModifyModalProps {
  id: number;
}

const NoticeModifyModal = ({ id }: NoticeModifyModalProps) => {
  const notcieApi = new NotcieApi({ baseURL: Config.API_URL });
  const navigate = useNavigate();

  const setErrorModalText = useSetRecoilState(errorModalTextRecoil);
  const setCompleteModalState = useSetRecoilState(completeModalRecoil);
  const setNoticeModifyModalState = useSetRecoilState(noticeModifyModalRecoil);

  const [title, setTitle] = useState<string>('');
  const [content, setContent] = useState<string>('');

  const fetchNoticeModify = async () => {
    try {
      const { data } = await notcieApi.noticeControllerGetNotice(id, {
        headers: {
          Authorization: `Bearer ${String(sessionStorage.getItem('accessToken'))}`,
          'Content-Type': 'application/json',
        },
      });
      setTitle(data.title);
      setContent(data.content);
    } catch (err: any) {}
  };

  const handleSubmit = async () => {
    if (title.trim() === '' || content.trim() === '') {
      setErrorModalText('빈 칸을 확인해 주세요.');
      return;
    }

    const dto: UpdateNoticeDtoTx = {
      title,
      content,
    };

    try {
      await notcieApi.noticeControllerUpdateNotice(id, dto, {
        headers: {
          Authorization: `Bearer ${String(sessionStorage.getItem('accessToken'))}`,
          'Content-Type': 'application/json',
        },
      });
      setCompleteModalState(true);
    } catch (err: any) {}
  };

  useEffect(() => {
    fetchNoticeModify();
  }, []);

  return (
    <>
      <ModalType1 width={560}>
        <div className="title-box flex aic jcsb">
          <h1>공지사항 수정</h1>
          <button
            className="x-btn img-box"
            onClick={() => setNoticeModifyModalState(false)}
          >
            <img src="/img/ico_x_444.svg" alt="" />
          </button>
        </div>
        <div className="cnt-area flex fdc">
          <div className="cnt-wrap flex fdc">
            <div className="cnt-box flex fdc">
              <div className="cnt-title-box flex jcsb aie">
                <div className="left-box">
                  <h2 className="tm">기본 정보</h2>
                </div>
                <div className="right-box flex">
                  <h3>
                    <span className="inblock">*</span>필수 항목
                  </h3>
                </div>
              </div>
              <CS.TableType2>
                <table>
                  <tbody>
                    <tr>
                      <th>
                        제목<span className="star-point">*</span>
                      </th>
                      <td colSpan={3}>
                        <IS.TextInputType1
                          style={{ width: 414 }}
                          type="text"
                          value={title}
                          onChange={(e) => setTitle(e.target.value)}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>
                        내용<span className="star-point">*</span>
                      </th>
                      <td colSpan={3}>
                        <IS.TextAreaType1
                          style={{ width: 414, height: 300 }}
                          value={content}
                          onChange={(e) => setContent(e.target.value)}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </CS.TableType2>
            </div>
          </div>
          <div className="btn-wrap">
            <BS.Btn2Type3
              type="button"
              onClick={() => setNoticeModifyModalState(false)}
            >
              취소
            </BS.Btn2Type3>
            <BS.Btn2Type4 type="button" onClick={handleSubmit}>
              등록
            </BS.Btn2Type4>
          </div>
        </div>
      </ModalType1>
    </>
  );
};

export default NoticeModifyModal;
